// extracted by mini-css-extract-plugin
export default {"container":"f0-z"};